import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'addressInput',
    'addressFormField',
    'addressInputSubmit',
    'addressSpinner',
  ];

  connect() {
    this.addressInputTarget.addEventListener(
      'keyup',
      this.debounce(() => this.addressUpdated.bind(this))
    );
  }

  addressUpdated() {
    if (this.addressInputTarget.value.length < 3) return;

    this.addressFormFieldTarget.value = this.addressInputTarget.value;
    this.addressInputSubmitTarget.style.display = 'none';
    this.addressSpinnerTarget.classList.remove('d-none');
    this.addressFormFieldTarget.form.requestSubmit();
  }

  debounce(func) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(func.apply(args), 1000);
    };
  }
}
